export enum VideoPreloadValue {
  Auto = 'auto',
  MetaData = 'metadata',
  None = 'none',
}
